import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import DoughnutChart from "../charts/generic/DoughnutChart"
import ChartComparison from "../ChartComparison"

function NumberOfLogins({ exportEndpoint, appliedFilters, data, subtitleKey }) {
  const hasComparisonData = false //!!(data[1] && data[1].value)
  const titleKey = "Widgets.NumberOfLogins.Title"
  return (
    <Widget
      columns={1}
      helpKey="Widgets.NoOfLogins.Help"
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
    >
      <DoughnutChart data={data} hasComparison={hasComparisonData} titleKey={titleKey} subtitleKey={subtitleKey}>
        {hasComparisonData && (
          <ChartComparison
            baseValue={data[0].value}
            comparisonOneValue={data[1] && data[1].value ? data[1].value : null}
            comparisonOneText="Common.LastSixMonths"
            comparisonTwoValue={data[2] && data[2].value ? data[2].value : null}
            comparisonTwoText="Common.LastTwelveMonths"
            usePercentage
            increaseIsGood
            translateText
          />
        )}
      </DoughnutChart>
    </Widget>
  )
}

NumberOfLogins.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired
}

export default NumberOfLogins



// WEBPACK FOOTER //
// ./src/components/widgets/NumberOfLogins.jsx